import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySiteLabelMeta } from "@/utils/dynamicManifest";

/**
 * Re-asserts the per-host PWA install label meta tags
 * (apple-mobile-web-app-title, application-name) on every SPA navigation.
 * Some browsers / Helmet interactions can clear or override these between
 * route transitions, which would change the home-screen label seen at
 * install-prompt time. Idempotent and cheap.
 */
export function SiteLabelMetaSync() {
  const location = useLocation();
  useEffect(() => {
    applySiteLabelMeta();
  }, [location.pathname]);
  return null;
}
